import { render, staticRenderFns } from "./DocumentsContainer.vue?vue&type=template&id=9e69e64c"
import script from "./DocumentsContainer.vue?vue&type=script&lang=ts"
export * from "./DocumentsContainer.vue?vue&type=script&lang=ts"
import style0 from "./DocumentsContainer.vue?vue&type=style&index=0&id=9e69e64c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports